import "./Loader.css";

interface LoaderProps {
  size?: number;
}

const Loader = ({ size = 48 }: LoaderProps) => {
  return (
    <div className="loaderWrapper">
      <div className="loaderSpinner" style={{ width: size, height: size }} />
    </div>
  );
};

export default Loader;
